const UnCheckIcon = () => (
  <svg
    className="un-checked-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <rect x="1" y="1" width="18" height="18" rx="3" strokeWidth="2" />
  </svg>
);

export default UnCheckIcon;
